module.exports = __webpack_public_path__ + "assets/img/index1.8544be0c.png";